<template>
  <v-app>
    <v-app-bar
      app
      color="primary"
      dark
    >
      <div class="d-flex align-center" @click="toHome">
        <h1>Margit 🌻</h1>
      </div>
      <v-spacer></v-spacer>
      <v-btn outlined @click="logout" v-if="userFetched">Logout</v-btn>
    </v-app-bar>

    <v-content class="decent-back">
      <router-view></router-view>
    </v-content>
    <v-bottom-navigation
            app
            color="accent"
            v-if="userFetched"
    >
      <v-btn to="/thoughts" replace>
        <span>Gedanken</span>
        <v-icon>mdi-thought-bubble</v-icon>
      </v-btn>
      <v-btn to="/lyrics" replace>
        <span>Text</span>
        <v-icon>mdi-music-circle</v-icon>
      </v-btn>
      <v-btn to="/cloud" replace>
        <span>Wolke</span>
        <v-icon>mdi-heart</v-icon>
      </v-btn>
      <v-btn to="trip" replace>
        <span>Ausflug</span>
        <v-icon>mdi-map-marker</v-icon>
      </v-btn>
    </v-bottom-navigation>
  </v-app>
</template>

<script>
  import firebase from "firebase/app";
  import "firebase/auth";
export default {
  name: 'App',

  components: {
  },

  data: () => ({
  }),
  methods: {
    toHome() {
      // eslint-disable-next-line no-unused-vars
      this.$router.push('/').catch(err => {});
    },
    logout() {
      firebase.auth().signOut();
    }
  },
  computed: {
    userFetched () {
      return !!this.$store.state.user;
    }
  }
};
</script>

<style>
  .v-item-group.v-bottom-navigation .v-btn.v-size--default {
    height: inherit;
  }
  .decent-back {
    background-color: rgba(0, 132, 61, 0.08);
  }
</style>
